var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"phone\">\n <path d=\"m31.184 12l-19.172 1.2305c-0.23438 20.168 2.5938 37.273 20.484 55.164 17.992 17.992 34.105 19.82 54.273 19.586l1.2305-19.172-19.125-2.8047c-5.1016 5.1016-10.203 10.199-10.203 10.199s-10.039-3.918-20.004-13.883c-9.9688-9.9648-14.883-21-14.883-21s6.1211-6.1211 10.203-10.199z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/phone.icon
// module id = 43
// module chunks = 168707334958949